
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'StatsEmptyState',
  props: {
    icon: {
      type: String,
      default: 'fa-thin fa-chart-line',
    },
    message: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
